// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CARD */
.suggested-card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    padding: 14px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    transition: all 0.25s ease;
    margin-bottom: 15px;
  }
  
  .suggested-card:hover {
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
  }
  
  /* HEADER */
  .suggested-header {
    display: flex;
    justify-content: flex-end;
  }
  
  .badge {
    background: var(--primary-100);
    color: #ffffff;
    font-size: 11px;
    padding: 4px 10px;
    border-radius: 999px;
    font-weight: 600;
  }
  
  /* BODY */
  .suggested-body {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  
  .avatar {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
  }
  
  .avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .avatar-placeholder {
    width: 100%;
    height: 100%;
    /* background: linear-gradient(135deg, #0f172a, #2563eb) !important; */
    color: var(--primary-200);
    font-size: 22px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  /* INFO */
  .info {
    flex: 1 1;
  }
  
  .info h4 {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: #020617;
  }
  
  .info p {
    margin: 2px 0;
    font-size: 13px;
    color: #475569;
  }
  
  /* ACTIONS */
  .suggested-actions {
    display: flex;
    gap: 10px;
    margin-top: 6px;
  }
  
  .suggested-actions button {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 8px 10px;
    font-size: 13px;
    font-weight: 500;
    border-radius: 10px;
    cursor: pointer;
    border: none;
    transition: all 0.2s ease;
  }
  
  /* LIKE */
  .suggested-actions .like {
    background: #fee2e2;
    color: #dc2626;
  }
  
  .suggested-actions .like:hover {
    background: #fecaca;
  }
  
  /* VIEW */
  .suggested-actions .view {
    background: #f1f5f9;
    color: #020617;
  }
  
  .suggested-actions .view:hover {
    background: #e2e8f0;
  }
  
  /* MOBILE */
  @media (max-width: 600px) {
    .suggested-actions {
      flex-direction: column;
    }
  }`, "",{"version":3,"sources":["webpack://./src/componentsL/matching/SuggestedProfileCard.css"],"names":[],"mappings":"AAAA,SAAS;AACT;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,2CAA2C;IAC3C,2BAA2B;EAC7B;;EAEA,WAAW;EACX;IACE,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;IAC9B,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA,SAAS;EACT;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sEAAsE;IACtE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,SAAS;EACT;IACE,SAAO;EACT;;EAEA;IACE,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,cAAc;EAChB;;EAEA,YAAY;EACZ;IACE,aAAa;IACb,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,yBAAyB;EAC3B;;EAEA,SAAS;EACT;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,SAAS;EACT;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,WAAW;EACX;IACE;MACE,sBAAsB;IACxB;EACF","sourcesContent":["/* CARD */\n.suggested-card {\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 14px;\n    padding: 14px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    transition: all 0.25s ease;\n    margin-bottom: 15px;\n  }\n  \n  .suggested-card:hover {\n    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.08);\n    transform: translateY(-2px);\n  }\n  \n  /* HEADER */\n  .suggested-header {\n    display: flex;\n    justify-content: flex-end;\n  }\n  \n  .badge {\n    background: var(--primary-100);\n    color: #ffffff;\n    font-size: 11px;\n    padding: 4px 10px;\n    border-radius: 999px;\n    font-weight: 600;\n  }\n  \n  /* BODY */\n  .suggested-body {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n  }\n  \n  .avatar {\n    width: 58px;\n    height: 58px;\n    border-radius: 50%;\n    overflow: hidden;\n    flex-shrink: 0;\n  }\n  \n  .avatar img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .avatar-placeholder {\n    width: 100%;\n    height: 100%;\n    /* background: linear-gradient(135deg, #0f172a, #2563eb) !important; */\n    color: var(--primary-200);\n    font-size: 22px;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  /* INFO */\n  .info {\n    flex: 1;\n  }\n  \n  .info h4 {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: #020617;\n  }\n  \n  .info p {\n    margin: 2px 0;\n    font-size: 13px;\n    color: #475569;\n  }\n  \n  /* ACTIONS */\n  .suggested-actions {\n    display: flex;\n    gap: 10px;\n    margin-top: 6px;\n  }\n  \n  .suggested-actions button {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 8px 10px;\n    font-size: 13px;\n    font-weight: 500;\n    border-radius: 10px;\n    cursor: pointer;\n    border: none;\n    transition: all 0.2s ease;\n  }\n  \n  /* LIKE */\n  .suggested-actions .like {\n    background: #fee2e2;\n    color: #dc2626;\n  }\n  \n  .suggested-actions .like:hover {\n    background: #fecaca;\n  }\n  \n  /* VIEW */\n  .suggested-actions .view {\n    background: #f1f5f9;\n    color: #020617;\n  }\n  \n  .suggested-actions .view:hover {\n    background: #e2e8f0;\n  }\n  \n  /* MOBILE */\n  @media (max-width: 600px) {\n    .suggested-actions {\n      flex-direction: column;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
